// extracted by mini-css-extract-plugin
module.exports = {"right":"LineBreak_right__ghK9W","left":"LineBreak_left__XPeJ4","center":"LineBreak_center__8+fmV","textless":"LineBreak_textless__fd+bL"};